import React, { useEffect, useState } from 'react';
import clsx from 'clsx';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import List from '@material-ui/core/List';
import CssBaseline from '@material-ui/core/CssBaseline';
import IconButton from '@material-ui/core/IconButton';
import ListItem from '@material-ui/core/ListItem';
import { FaBars, FaCity, FaExternalLinkAlt, FaFileDownload, FaFileUpload, FaHome, FaHospital, FaLaptop, FaRegChartBar, FaStickyNote, FaUserClock, FaUserFriends, FaUserPlus } from 'react-icons/all';
import { Link, Route, Switch, useHistory } from 'react-router-dom';
import { HeaderBar } from './HeaderBar';
import PrivateRoute from '../auth/PrivateRoute';
import Debug from '../Debug';
import Logout from '../auth/Logout';
import Login from '../auth/Login';
import { Badge, Dialog, DialogActions, DialogContent, FormControl, Grid, ListItemIcon, ListItemText, MenuItem, Select } from '@material-ui/core';
import AuthContext from '../auth/AuthContext';
import { SDialogButton, SDialogSubtitle, SDialogTitle, SInputLabel } from '../common/BCommonComponents';
import { toast } from 'react-toastify';
import { Home } from '../Home';
import { PuntiServizio } from '../puntiServizio/PuntiServizio';
import { Contatto } from '../Contatto';
import { Prestazioni } from '../Prestazioni';
import { CanaleAccessoEnum, UserRole } from '../common/Dtos';
import { Backoffice } from '../Backoffice';
import { Interruzioni } from '../Interruzioni';
import { DettaglioPuntoServizio } from '../puntiServizio/DettaglioPuntoServizio';
import { Operatori } from '../operatori/Operatori';
import { DettaglioOperatore } from '../operatori/DettaglioOperatore';
import { ImpostazioniOperatore } from '../ImpostazioniOperatore';
import { Report } from '../Report';
import { Export } from '../Export';
import { Cooperative } from '../cooperative/Cooperative';
import { DettaglioCooperativa } from '../cooperative/DettaglioCooperativa';
import { Upload } from '../Upload';
import { Adiba } from '../adiba/Adiba';
import { UploadUnificatoreAsl } from '../UploadUnificatoreAsl';
import ConfermaInvioEmailVerifica from '../ConfermaInvioEmailVerifica';
import VerificaEmail from '../VerificaEmail';

const drawerWidth = 240;

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		root: {
			display: 'flex',
		},
		appBar: {
			zIndex: theme.zIndex.drawer + 1,
			backgroundColor: '#002c74',
			transition: theme.transitions.create(['width', 'margin'], {
				easing: theme.transitions.easing.sharp,
				duration: theme.transitions.duration.leavingScreen,
			}),
			width: `calc(100% - ${theme.spacing(9) + 1}px)`
		},
		appBarShift: {
			marginLeft: drawerWidth,
			width: `calc(100% - ${drawerWidth}px)`,
			transition: theme.transitions.create(['width', 'margin'], {
				easing: theme.transitions.easing.sharp,
				duration: theme.transitions.duration.enteringScreen,
			}),
		},
		appBarNotAuthenticated: {
			width: '100%'
		},
		menuButton: {
			marginRight: 36,
			color: 'rgba(181,187,191,0.87) !important',
			paddingLeft: 16
		},
		hide: {
			display: 'none',
		},
		drawer: {
			width: drawerWidth,
			flexShrink: 0,
			whiteSpace: 'nowrap',
			backgroundColor: '#88959E !important',
			color: 'rgba(255,255,255,0.87) !important'
		},
		drawerOpen: {
			backgroundColor: '#88959E !important',
			color: 'rgba(255,255,255,0.87) !important',
			width: drawerWidth,
			transition: theme.transitions.create('width', {
				easing: theme.transitions.easing.sharp,
				duration: theme.transitions.duration.enteringScreen,
			}),
		},
		drawerClose: {
			backgroundColor: '#88959E !important',
			color: 'rgba(255,255,255,0.87) !important',
			transition: theme.transitions.create('width', {
				easing: theme.transitions.easing.sharp,
				duration: theme.transitions.duration.leavingScreen,
			}),
			overflowX: 'hidden',
			width: theme.spacing(7) + 1,
			[theme.breakpoints.up('sm')]: {
				width: theme.spacing(9) + 1,
			},
		},
		toolbar: {
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'start',
			padding: theme.spacing(0, 1),
			// necessary for content to be below app bar
			...theme.mixins.toolbar,
		},
		content: {
			flexGrow: 1,
			padding: '19px 40px',
			backgroundColor: '#ffffff',
		},
		menuIcon: {
			color: 'rgba(181,187,191,0.87) !important'
		}
	}),
);

export interface MatSidenavProps {
	version: string;
}

function MatSideNav(props: MatSidenavProps) {
	const { version } = props;
	const auth = React.useContext(AuthContext);
	const classes = useStyles();
	const [open, setOpen] = React.useState(true);
	const [openDialog, setOpenDialog] = React.useState(false);
	const history = useHistory();

	const handleDrawer = () => {
		setOpen(!open);
	};

	const handleOpenNuovoContatto = () => {
		setOpenDialog(true);
	}

	const handleCloseNuovoContatto = (canaleSelected?: string) => {
		setOpenDialog(false);
		if (canaleSelected) {
			auth.state.axiosInstance?.post('/api/contatto/insert', {
				tipoContatto: canaleSelected.toUpperCase(),
				puntoServizioId: auth.state.puntoServizioLogged?.id,
				cooperativaId: auth.state.cooperativa,
				operatore: auth.state.login
			})
				.then(res => {
					history.push("/contatto/" + canaleSelected + "/" + res.data.id);

				})
				.catch(error => {
					toast.error('🛑 Errore durante il login');
					console.log(error)
				});
		}
	}

	const isAdiba = () => {
		return window.location.pathname.indexOf('adiba') >= 0;
	}

	const openKnowage = () => {
		auth.state.axiosInstance?.get('/api/knowage/link')
			.then(res => {
				window.open(res.data, '_blank', 'noopener,noreferrer');
			}).catch(error => {
				toast.error('🛑 Errore durante l\'autenticazione su Knowage!');
				console.log(error);
			});
	}

	return (
		<div className={classes.root}>
			<CssBaseline />
			<AppBar
				position="fixed"
				className={clsx(classes.appBar, {
					[classes.appBarShift]: open,
				}, {
					[classes.appBarNotAuthenticated]: !auth.state.isAuthenticated || isAdiba()
				})}
			>
				<Toolbar>
					<HeaderBar />
				</Toolbar>
			</AppBar>
			{auth.state.isAuthenticated && !isAdiba() &&
				<Drawer
					variant="permanent"
					className={clsx(classes.drawer, {
						[classes.drawerOpen]: open,
						[classes.drawerClose]: !open,
					})}
					classes={{
						paper: clsx({
							[classes.drawerOpen]: open,
							[classes.drawerClose]: !open,
						}),
					}}
				>
					<div className={classes.toolbar}>
						<IconButton className={classes.menuIcon} onClick={handleDrawer}>
							<FaBars />
						</IconButton>
					</div>
					<List>
						{auth.state.roles?.find(r => r === UserRole.SUPERVISOR || r === UserRole.ADMIN || r === UserRole.RESPONSIBLE || r === UserRole.OPERATOR) &&
							<ListItem button
								component={Link}
								to="/dashboard"
								className="hover-link">
								<ListItemIcon className={classes.menuIcon}><FaHome size={25} /></ListItemIcon>
								<ListItemText primary="Home" />
							</ListItem>
						}
						{auth.state.puntoServizioLogged && !auth.state.puntoServizioLogged.puntoServizioConfig &&
							<ListItem button
								onClick={handleOpenNuovoContatto}
								className="hover-link">
								<ListItemIcon className={classes.menuIcon}><FaUserPlus size={25} /></ListItemIcon>
								<ListItemText primary="Nuovo Contatto" />
							</ListItem>
						}
						{auth.state.roles?.find(r => r === UserRole.SUPERVISOR || r === UserRole.ADMIN || r === UserRole.RESPONSIBLE || r === UserRole.OPERATOR) &&
							<ListItem button
								component={Link}
								to="/backoffice"
								className="hover-link">
								<ListItemIcon className={classes.menuIcon}>
									<Badge badgeContent={auth.state.backofficeInCorso} color="error">
										<FaLaptop size={25} />
									</Badge>
								</ListItemIcon>
								<ListItemText primary="Backoffice in Corso" />
							</ListItem>
						}
						{auth.state.roles?.find(r => r === UserRole.SUPERVISOR || r === UserRole.ADMIN || r === UserRole.RESPONSIBLE) &&
							<ListItem button
								component={Link}
								to="/puntiservizio"
								className="hover-link">
								<ListItemIcon className={classes.menuIcon}><FaHospital size={25} /></ListItemIcon>
								<ListItemText primary="Punti di Servizio" />
							</ListItem>
						}
						{auth.state.roles?.find(r => r === UserRole.SUPERVISOR || r === UserRole.ADMIN || r === UserRole.RESPONSIBLE) &&
							<ListItem button
								component={Link}
								to="/operatori"
								className="hover-link">
								<ListItemIcon className={classes.menuIcon}><FaUserFriends size={25} /></ListItemIcon>
								<ListItemText primary="Operatori" />
							</ListItem>
						}
						{auth.state.roles?.find(r => r === UserRole.SUPERVISOR || r === UserRole.ADMIN || r === UserRole.RESPONSIBLE || r === UserRole.OPERATOR) &&
							<ListItem button
								component={Link}
								to="/prestazioni"
								className="hover-link">
								<ListItemIcon className={classes.menuIcon}><FaStickyNote size={25} /></ListItemIcon>
								<ListItemText primary="Archivio Prestazioni" />
							</ListItem>
						}
						{auth.state.roles?.find(r => r === UserRole.SUPERVISOR || r === UserRole.ADMIN || r === UserRole.RESPONSIBLE || r === UserRole.OPERATOR) &&
							<ListItem button
								component={Link}
								to="/interruzioni"
								className="hover-link">
								<ListItemIcon className={classes.menuIcon}><FaUserClock size={25} /></ListItemIcon>
								<ListItemText primary="Interruzioni" />
							</ListItem>
						}
						{auth.state.roles?.find(r => r === UserRole.SUPERVISOR || r === UserRole.ADMIN || r === UserRole.RESPONSIBLE || r === UserRole.REPORT) &&
							<ListItem button
								component={Link}
								to="/report"
								className="hover-link">
								<ListItemIcon className={classes.menuIcon}><FaRegChartBar size={25} /></ListItemIcon>
								<ListItemText primary="Report" />
							</ListItem>
						}
						{auth.state.roles?.find(r => r === UserRole.SUPERVISOR || r === UserRole.ADMIN || r === UserRole.RESPONSIBLE || r === UserRole.REPORT) &&
							<ListItem button
								component={Link}
								to="/export"
								className="hover-link">
								<ListItemIcon className={classes.menuIcon}><FaFileDownload size={25} /></ListItemIcon>
								<ListItemText primary="Export" />
							</ListItem>
						}
						{auth.state.roles?.find(r => r === UserRole.SUPERVISOR || r === UserRole.ADMIN || r === UserRole.RESPONSIBLE) &&
							<ListItem button
								component={Link}
								to="/upload"
								className="hover-link">
								<ListItemIcon className={classes.menuIcon}><FaFileUpload size={25} /></ListItemIcon>
								<ListItemText primary="Import Call Center" />
							</ListItem>
						}
						{auth.state.roles?.find(r => r === UserRole.UNIFICATORE) &&
							<ListItem button
								component={Link}
								to="/import-cup-unico"
								className="hover-link">
								<ListItemIcon className={classes.menuIcon}><FaFileUpload size={25} /></ListItemIcon>
								<ListItemText primary="Import CUP Unico" />
							</ListItem>
						}
						{auth.state.roles?.find(r => r === UserRole.ADMIN) &&
							<ListItem button
								component={Link}
								to="/cooperative"
								className="hover-link">
								<ListItemIcon className={classes.menuIcon}><FaCity size={25} /></ListItemIcon>
								<ListItemText primary="Cooperative" />
							</ListItem>
						}
						{auth.state.roles?.find(r => r === UserRole.SUPERVISOR || r === UserRole.ADMIN) &&
							<ListItem button
								onClick={openKnowage}
								className="hover-link">
								<ListItemIcon className={classes.menuIcon}><FaExternalLinkAlt size={25} /></ListItemIcon>
								<ListItemText primary="Knowage" />
							</ListItem>
						}
					</List>
					<p className="fixed-bottom pl-3 mb-2">Versione: {version}</p>
				</Drawer>
			}
			<main className={classes.content}>
				<div className={classes.toolbar} />
				<Switch>
					<PrivateRoute redirectPath="/login" exact path={["/", "/dashboard"]}>
						<Home />
					</PrivateRoute>
					<PrivateRoute redirectPath="/login" exact path={["/contatto/:tipo/:id"]}>
						<Contatto />
					</PrivateRoute>
					<PrivateRoute redirectPath="/login" exact path={["/backoffice"]}>
						<Backoffice />
					</PrivateRoute>
					<PrivateRoute redirectPath="/login" exact path={["/prestazioni"]}>
						<Prestazioni />
					</PrivateRoute>
					<PrivateRoute redirectPath="/login" exact path={["/interruzioni"]}>
						<Interruzioni />
					</PrivateRoute>
					<PrivateRoute redirectPath="/login" exact path={["/debug"]}>
						<Debug />
					</PrivateRoute>
					<PrivateRoute redirectPath="/login" exact path={["/logout"]}>
						<Logout />
					</PrivateRoute>
					<PrivateRoute redirectPath="/login" exact path={["/puntiservizio"]}>
						<PuntiServizio />
					</PrivateRoute>
					<PrivateRoute redirectPath="/login" exact path={["/dettaglio/puntoservizio/:id"]}>
						<DettaglioPuntoServizio />
					</PrivateRoute>
					<PrivateRoute redirectPath="/login" exact path={["/operatori"]}>
						<Operatori />
					</PrivateRoute>
					<PrivateRoute redirectPath="/login" exact path={["/dettaglio/operatore/:id?"]}>
						<DettaglioOperatore />
					</PrivateRoute>
					<PrivateRoute redirectPath="/login" exact path={["/impostazioniutente"]}>
						<ImpostazioniOperatore />
					</PrivateRoute>
					<PrivateRoute redirectPath="/login" exact path={["/report"]}>
						<Report />
					</PrivateRoute>
					<PrivateRoute redirectPath="/login" exact path={["/export"]}>
						<Export />
					</PrivateRoute>
					<PrivateRoute redirectPath="/login" exact path={["/cooperative"]}>
						<Cooperative />
					</PrivateRoute>
					<PrivateRoute redirectPath="/login" exact path={["/dettaglio/cooperativa/:id?"]}>
						<DettaglioCooperativa />
					</PrivateRoute>
					<PrivateRoute redirectPath="/login" exact path={["/upload"]}>
						<Upload />
					</PrivateRoute>
					<PrivateRoute redirectPath="/login" exact path={["/import-cup-unico"]}>
						<UploadUnificatoreAsl />
					</PrivateRoute>
					<Route path={["/adiba/:codiceFiscale/:token"]}>
						<Adiba />
					</Route>
					<Route path={['/check-email/:code']}>
						<VerificaEmail />
					</Route>
					<Route path={['/invio-email-verifica']}>
						<ConfermaInvioEmailVerifica />
					</Route>
					<Route path='/login'>
						<Login />
					</Route>
				</Switch>
			</main>
			<NuovoContattoDialog open={openDialog} onClose={handleCloseNuovoContatto} canaleDefault={auth.state.canale ? auth.state.canale : ''}></NuovoContattoDialog>
		</div>
	);
}

export interface NuovoContattoDialogProps {
	open: boolean;
	onClose: (canale?: string) => void;
	canaleDefault: string;
}

function NuovoContattoDialog(props: NuovoContattoDialogProps) {
	const { onClose, open, canaleDefault } = props;
	const [canale, setCanale] = useState<string>(canaleDefault);

	useEffect(() => {
	}, [canale])

	useEffect(() => {
		setCanale(canaleDefault);
	}, [open])

	const handleConfirmation = () => {
		onClose(canale);
	};

	const handleClose = () => {
		onClose();
	};

	const handleCanaleChangee = (event: React.ChangeEvent<{ value: unknown }>) => {
		setCanale(event.target.value as string);
	};

	const useStyles = makeStyles((theme: Theme) =>
		createStyles({
			formControl: {
				// margin: theme.spacing(1),
				width: '100%',
			},
			selectEmpty: {
				width: '100%',
				margin: '0',
			},
		}),
	);

	const classes = useStyles();

	return (
		<Dialog
			open={open}>
			<SDialogTitle className="pb-0" id="simple-dialog-title">NUOVO CONTATTO
			</SDialogTitle>
			<SDialogSubtitle className="mx-4">per continuare, seleziona il Canale di Accesso</SDialogSubtitle>
			<DialogContent>
				<Grid container spacing={0} className="w-100">
					<Grid item xs={12}>
						<FormControl variant="outlined" className={classes.formControl}>
							<SInputLabel id="canaleAccesso">Canale di Accesso</SInputLabel>
							<Select
								required
								labelId="canaleAccesso"
								id="canaleAccessoSelect"
								className={classes.selectEmpty}
								label="Canale di Accesso"
								value={canale}
								onChange={handleCanaleChangee}
								MenuProps={{
									anchorOrigin: {
										vertical: "bottom",
										horizontal: "left"
									},
									transformOrigin: {
										vertical: "top",
										horizontal: "left"
									},
									getContentAnchorEl: null
								}}
							>
								<MenuItem value={CanaleAccessoEnum.FRONTOFFICE} key={CanaleAccessoEnum.FRONTOFFICE}>Frontoffice</MenuItem>
								<MenuItem value={CanaleAccessoEnum.CALL_CENTER} key={CanaleAccessoEnum.CALL_CENTER}>Call Center</MenuItem>
								<MenuItem value={CanaleAccessoEnum.MAIL} key={CanaleAccessoEnum.MAIL}>Mail</MenuItem>
							</Select>
						</FormControl>
					</Grid>
				</Grid>
			</DialogContent>
			<DialogActions className="p-4">
				<SDialogButton className="float-right" onClick={handleConfirmation}>CONFERMA</SDialogButton>
				<SDialogButton className="float-right" onClick={handleClose}>ANNULLA</SDialogButton>
			</DialogActions>
		</Dialog>
	);

}

export default MatSideNav;
